import swal from "sweetalert2";
import { AttributeModel } from "../main/dynamic/model/attribute.model";
import { OptionModel } from "../main/dynamic/model/option.model";

export abstract class ValidationStrategy {
    
    protected attribute: AttributeModel
    protected injectedOptions: OptionModel[]

    constructor(attribute: AttributeModel, optionsInjection: OptionModel[] = []) {
        this.attribute = attribute
        this.injectedOptions = optionsInjection
    }

    protected get isDisabled(): boolean {
        return this.attribute.options
            .some(opt => opt.key.toLowerCase() == 'disabled' && opt.value.toLowerCase() == "true");
    }

    protected get isHidden(): boolean {
        return this.attribute.options
            .some(opt => opt.key.toLowerCase() == "view" && opt.value.toLowerCase() == "hide");
    }

    protected get isRequired(): boolean {
        return this.injectedOptions
                 .some(opt => opt.key.toLowerCase() == 'required' && opt.value.toLowerCase() == "true") ||
               (this.attribute.options && 
                this.attribute.options.some(opt => opt.key.toLowerCase() == 'required' && opt.value.toLowerCase() == "true"));
    }

    protected addToOptionInjection(option: OptionModel) {
        let opt = this.injectedOptions
            .find(opt => opt.key.toLowerCase() == option.key.toLowerCase())

        if(opt) {
            opt.value = option.value
        } else {
            this.injectedOptions.push(option)
        }
    }

    public getErrorMessage(errorType: string = "error") {
        let errorOpt = this.attribute.options
            .find(opt => opt.key.toLowerCase() == errorType.toLowerCase());
        let fieldName = this.attribute.key;

        let titleOpt = this.attribute.options
            .find(opt => opt.key.toLowerCase() == "title");

        if (titleOpt) {
            fieldName = titleOpt.value;
        }

        return errorOpt ? errorOpt.value : `O campo "${fieldName}" não foi preenchido corretamente.`;
    }

    public showError(errorType: string = "error") {
        let errorMessage = this.getErrorMessage(errorType);
            
        swal.fire("Atenção", errorMessage, "error");
    }

    public abstract validate(): boolean

    protected validateCompleteName(): boolean{

        var splitted = this.attribute.value.split(' ')

        if (splitted.length <2){
            return false;
        } else {
            return true
        }
    }
}